<template>
<div class="upload-table-component" style="float: left; width: 100%;">
  <!-- Modal de edição -->
  <div class="image-editable" v-if="editable">
    <div class="body-editable pb-3">
      <div class="col-lg-12 text-right w-100">
        <a href="javascirpt:void(0)" @click="cancel()" class="editable-close">
          <i class="fa fa-times"></i>
          &nbspFechar
        </a>
      </div>
      <strong class="col-lg-12 w-100 p-3">Legendas</strong>
      <hr class="mb-0">
      <div class="form-group" v-if="editable.type">
        <div class="col-lg-12" style="overflow:hidden;">
          <div class="bg-preview" :style="'background-image: url(' + editable.url + ')'"></div>
          <div class="frame-preview-image" :style="'background-image: url(' + editable.url + ')'"></div>
        </div>
      </div>
      <div class="col-lg-12 mt-4">
        <div class="form-group">
          <label>Título</label>
          <input type="text" class="form-control" v-model="editable.custom_properties.title">
        </div>
        <div class="form-group">
          <label>Descrição</label>
          <textarea name="name" class="form-control" v-model="editable.custom_properties.description" style="min-height:109px !important"></textarea>
        </div>
        <div class="form-group text-right">
          <button type="button" class="btn btn-success" @click="saveLegend()">Salvar</button>
        </div>
      </div>
    </div>
  </div>
  <div class="upload" v-if="show">
    <div class="table-responsive">
      <table class="table table-hover upload-table">
        <thead v-if="files.length">
          <tr>
            <th>#</th>
            <th>Thumbnail</th>
            <th>Nome</th>
            <th>Status</th>
            <th class="text-center">Ações</th>
          </tr>
        </thead>
        <tbody>

          <tr v-if="!files.length">
            <td colspan="7">
              <div class="text-center p-2">
                <label :for="id" class="btn btn-lg btn-primary">Selecione {{ multiple ? 'os arquivos' : 'o arquivo'}} </label>
              </div>
            </td>
          </tr>

          <tr v-for="(file, index) in files" :key="file.id" :class="file.progress === '100.00' ? 'none' : ''">
            <td>{{index}}</td>
            <td>
              <img v-if="file.thumb" :src="file.thumb" width="40" height="auto"/>
              <span v-else style="display: inline-block; width: 40px; text-align: right;"><i class="fa file-type-icon fa-file-o"></i></span>
            </td>
            <td>
              <div class="filename">
                <a @click="edit(i)" v-if="file.type.split('/')[0].type === 'image'">{{file.name}}</a>
                <a v-else>{{file.name}}</a>
              </div>
            </td>
            <td v-if="file.active || file.progress !== '0.00'">
              <div class="progress">
                <div
                  :class="{'progress-bar': true, 'progress-bar-striped': true, 'bg-danger': file.error, 'progress-bar-animated': file.active}"
                  role="progressbar"
                  :style="{width: file.progress + '%'}">
                    {{file.progress}}%
                </div>
              </div>
            </td>
            <td v-else-if="file.error">{{ file.error }}</td>
            <td v-else-if="file.success">Sucesso!</td>
            <td v-else-if="file.active">Ativo</td>
            <td v-else>
              N/D
            </td>
            <td class="text-center">
              <div class="btn-group">
                <a
                  v-if="file.type.split('/')[0] === 'image'"
                  :class="{'dropdown-item': true, disabled: file.active || file.success || file.error === 'compressing'}"
                  href="javascript:void(0)"
                  @click.prevent="file.active || file.success || file.error === 'compressing' ? false :  onEditFileShow(file)">
                  <i class="fa fa-crop m-0"></i>
                </a>

                <a
                  href="javascript:void(0)"
                  @click.prevent="$refs[id].remove(file)">
                  <i class="fa fa-trash no-margin"></i>
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="example-foorer" v-if="show">
      <div class="btn-group">
        <file-upload
          class="btn btn-primary"
          :post-action="postAction"
          :extensions="extensions"
          :accept="accept"
          :multiple="mult"
          :directory="directory"
          :size="size || 0"
          :thread="thread < 1 ? 1 : (thread > 5 ? 5 : thread)"
          :drop="drop"
          :drop-directory="dropDirectory"
          :add-index="addIndex"
          :data="{
            collection: collection,
            width: minCroppedWidth ? minCroppedWidth : false,
            height: minCroppedHeight ? minCroppedHeight : false
            }"
          v-model="files"
          :input-id="id"
          :name="name"
          @input-file="inputFile"
          @input-filter="inputFilter"
          :ref="id">
          <i class="fa fa-folder"></i> Selecionar
        </file-upload>
        <!-- @input-filter="inputFilter" -->
        <!-- :name="collection" -->
        <!-- v-model="files" -->
      </div>

      <button type="button" class="btn btn-success" v-if="!$refs[id] || !$refs[id].active" @click.prevent="$refs[id].active = true">
        <i class="fa fa-arrow-up" id="uploader" aria-hidden="true"></i>
        Iniciar upload
      </button>

      <button type="button" class="btn btn-danger"  v-else @click.prevent="$refs[id].active = false">
        <i class="fa fa-stop" aria-hidden="true"></i>
        Parar upload
      </button>
    </div>
  </div>

  <ul class="full list-group" v-if="images.length" :class="{ 'mt-3': show }">
    <li class="list-group-item active">
      <div class="row">
        <div class="col-lg-3">
          Ações
        </div>
        <div class="col-lg-6">
          Nome do arquivo
        </div>
        <div class="col-lg-2">
          Data de upload
        </div>
      </div>
    </li>
    <draggable :list="images" class="col-lg-12 pl-0 pr-0 line-border" ghost-class="ghost" group="a" @end="handleDrop">
      <li class="list-group-item grabbable" v-for="(image, i) in images" :key="image[i]">
        <div class="row align-items-center">
          <div class="col-lg-3">
            <div class="row align-items-center">
              <a class="col-lg-2 grabbable" href="javascript:void(0)">
                <i class="fa fa-ellipsis-v d-inline" aria-hidden="true"></i>
              </a>
              <a class="col-lg-2" v-if="info" href="javascript:void(0)" @click="legend(i)"><i class="fa fa-pencil"></i></a>
              <a class="col-lg-2" v-if="image.mime_type.split('/')[0] == 'image'" :href="image.url" target="_blank"><i class="fa fa-eye"></i></a>
              <a class="col-lg-2" v-if="image.model_id" @click="download(image.download)" style="cursor: pointer;"><i class="fa fa-download"></i></a>
              <a class="col-lg-2" href="javascript:void(0)" @click="remove(i)"><i class="fa fa-trash"></i></a>
            </div>
          </div>
          <div class="col-lg-6 d-flex align-items-center">
            <div class="pr-2" v-if="image.mime_type.split('/')[0] == 'image'">
              <img :src="image.url" width="40px">
            </div>
            <a href="javascript:void(0)" v-if="info" @click="legend(i)">
              {{ image.custom_properties.title || image.name }}
            </a>
            <span v-else>
              {{ image.custom_properties.title || image.name }}
            </span>
          </div>
          <div class="col-lg-2">
            {{ convertDateToLocale(image.created_at) }}
          </div>
        </div>
      </li>
    </draggable>
  </ul>

  <div :class="{'modal-backdrop': false, 'fade': true, show: addData.show}"></div>

  <div :class="{modal: true, fade: true, show: addData.show}" id="modal-add-data" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add data</h5>
          <button type="button" class="close"  @click.prevent="addData.show = false">
            <span>&times;</span>
          </button>
        </div>
        <form @submit.prevent="onAddData">
          <div class="modal-body">
            <div class="form-group">
              <label for="name">Name:</label>
              <input type="text" class="form-control" required id="name"  placeholder="Please enter a file name" v-model="addData.name">
              <small class="form-text text-muted">Such as <code>filename.txt</code></small>
            </div>
            <div class="form-group">
              <label for="type">Type:</label>
              <input type="text" class="form-control" required id="type"  placeholder="Please enter the MIME type" v-model="addData.type">
              <small class="form-text text-muted">Such as <code>text/plain</code></small>
            </div>
            <div class="form-group">
              <label for="content">Content:</label>
              <textarea class="form-control" required id="content" rows="3" placeholder="Please enter the file contents" v-model="addData.content"></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click.prevent="addData.show = false">Close</button>
            <button type="submit" class="btn btn-primary">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div :class="{'modal-backdrop': true, 'fade': true, show: editFile.show}"></div>

  <div :class="{modal: true, fade: true, show: editFile.show}" id="modal-edit-file" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Editar arquivo</h5>
          <button type="button" class="close"  @click.prevent="editFile.show = false">
            <span>&times;</span>
          </button>
        </div>
        <form @submit.prevent="onEditorFile">
          <div class="modal-body">
            <div class="form-group" v-if="editFile.show && editFile.blob && editFile.type && editFile.type.substr(0, 6) === 'image/'">
              <label>Imagem: </label>
              <div class="edit-image">
                <img :src="editFile.blob" ref="editImage" />
              </div>

              <div class="edit-image-tool">
                <div class="btn-group" role="group">
                  <button type="button" class="btn btn-primary" @click="editFile.cropper.zoom('0.1')"><i class="fa fa-search-plus" aria-hidden="true"></i></button>
                  <button type="button" class="btn btn-primary" @click="editFile.cropper.zoom('-0.1')"><i class="fa fa-search-minus" aria-hidden="true"></i></button>
                </div>
                <div class="btn-group" role="group">
                  <button type="button" class="btn btn-primary" @click="editFile.cropper.move('-10', '0')"><i class="fa fa-arrow-left" aria-hidden="true"></i></button>
                  <button type="button" class="btn btn-primary" @click="editFile.cropper.move('10', '0')"><i class="fa fa-arrow-right" aria-hidden="true"></i></button>
                  <button type="button" class="btn btn-primary" @click="editFile.cropper.move('0', '-10')"><i class="fa fa-arrow-up" aria-hidden="true"></i></button>
                  <button type="button" class="btn btn-primary" @click="editFile.cropper.move('0', '10')"><i class="fa fa-arrow-down" aria-hidden="true"></i></button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click.prevent="editFile.show = false">Fechar</button>
            <button type="submit" class="btn btn-primary">Salvar</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
</template>

<script>
  // https://github.com/fengyuanchen/cropperjs/blob/master/README.md#options
  import config from '@/../config'
  import Cropper from 'cropperjs'
  import axios from 'axios'
  import { get } from 'lodash'
  import FileUpload from 'vue-upload-component'
  import 'cropperjs/dist/cropper.min.css'
  import moment from 'moment'

  export default {
    props: {
      form: {},
      collection: {},
      accept: {},
      image: {},
      url: {},
      id: {},
      extensions: {},
      multiple: {},
      info: {
        type: Boolean,
        default: true
      },
      required: {
        type: Boolean,
        default: false
      },
      name: {},
      single: {},
      value: {},
      maximum: {},
      minCroppedWidth: {},
      minCroppedHeight: {}
    },

    components: {
      FileUpload
    },

    data () {
      return {
        show: true,
        files: [],
        putAction: '',
        editable: false,
        mult: true,
        minSize: 1024,
        size: 1024 * 1024 * 10,
        directory: false,
        drop: false,
        dropDirectory: false,
        addIndex: false,
        thread: 3,
        orignalDatas: [],
        postAction: config.local.API_URL.replace(/"(.*)"/, '$1') + '/media',
        headers: {},
        data: {
          collection: this.collection,
          title: '',
          description: ''
        },
        autoCompress: 1024 * 1024,
        uploadAuto: false,
        isOption: false,
        images: [],
        addData: {
          show: false,
          name: '',
          type: '',
          content: ''
        },
        editFile: {
          show: false,
          name: ''
        }
      }
    },

    mounted () {
      if (this.form[this.id]) {
        this.images = this.form[this.id]
        this.orignalDatas = JSON.parse(JSON.stringify(this.images))
      }

      if (typeof this.multiple === 'undefined') {
        this.mult = true
      } else {
        this.mult = this.multiple
      }
    },

    watch: {
      'editFile.show' (newValue, oldValue) {
        if (!newValue && oldValue) {
          this.$refs[this.id].update(this.editFile.id, { error: this.editFile.error || '' })
        }
        if (newValue) {
          this.$nextTick(function () {
            if (!this.$refs.editImage) {
              return
            }

            let cropper = new Cropper(this.$refs.editImage, {
              autoCrop: true,
              zoomOnWheel: false,
              cropBoxResizable: false,
              minCropBoxWidth: this.minCroppedWidth,
              minCropBoxHeight: this.minCroppedHeight,
              aspectRatio: this.minCroppedWidth / this.minCroppedHeight
            })

            this.editFile = {
              ...this.editFile,
              cropper
            }
          })
        }
      },

      'addData.show' (show) {
        if (show) {
          this.addData.name = ''
          this.addData.type = ''
          this.addData.content = ''
        }
      },

      images () {
        this.form[this.id] = []
        this.images.forEach((item) => {
          this.form[this.id].push(item.id)
        })
        if (!this.mult) {
          this.show = this.images.length === 0
        }
      },

      'form': {
        handler () {
          this.setRequiredProp()
        },
        deep: true
      }
    },

    methods: {

      setRequiredProp () {
        setTimeout(() => {
          const input = document.getElementById(`${this.id}`)
          if (input) {
            input.setAttribute('required', true)
          }
        }, 1000)
      },

      handleDrop ({ newIndex, oldIndex }) {
        const self = this

        if (!self.processing && newIndex !== oldIndex) {
          self.processing = true
          let previousId = null

          if (newIndex !== 0) {
            previousId = get(self.images[newIndex - 1], 'id', null)
          }

          let elementId = get(self.images[newIndex], 'id')

          const url = config.local.API_URL.replace(/"(.*)"/, '$1') + '/system/medias/' + elementId + '/after/' + previousId

          axios
            .put(url)
            .then((response) => {
              self.processing = false
              this.$toasted.success('Ordenação realizada com sucesso!')
            })
        }
      },

      download (file) {
        window.open(file, '_blank')
      },

      convertDateToLocale (date) {
        const dateObj = new Date(date)
        const result = moment(dateObj).format('DD/MM/YYYY')
        return result
      },

      saveLegend () {
        var i = this.editable.indice
        var url = this.url

        if (!this.images[i].model_id) {
          url = config.local.API_URL.replace(/"(.*)"/, '$1') + '/media'
        }

        if (this.images[i].id) {
          url += '/' + this.images[i].id
        }

        axios.post(url, {
          title: this.editable.custom_properties.title,
          description: this.editable.custom_properties.description
        })
          .then((resp) => {
            this.images[i].custom_properties = JSON.parse(JSON.stringify(this.editable.custom_properties))
            this.$toasted.success('Alterações realizadas com sucesso!')
            // window.location.reload()
            this.editable = false
          })
          .catch((err) => {
            console.log(err)
            this.$toasted.error('Ocorreu um erro no servidor tente novamente mais tarde')
            this.editable = false
          })
      },

      remove (i) {
        var nameImage = this.images[i].custom_properties.title ? this.images[i].custom_properties.title : this.images[i].name
        var confirm = window.confirm('Deseja remover o arquivo ' + nameImage + '?')
        if (!confirm) return false

        if (!this.images[i].model_id) {
          this.$nextTick(() => {
            this.images.splice(i, 1)
            this.$toasted.success('Arquivo removido com sucesso')
          })
          return
        }
        axios.delete(this.url + '/' + this.images[i].id)
          .then((resp) => {
            this.images.splice(i, 1)
            this.$toasted.success('Arquivo removido com sucesso')
            this.editable = false
          })
          .catch((err) => {
            console.log(err)
            this.$toasted.error('Ocorreu um erro no servidor tente novamente mais tarde')
          })
      },

      cancel () {
        this.editable = false
      },

      legend (i) {
        if (this.info) {
          this.editable = JSON.parse(JSON.stringify(this.images[i]))
          let type = this.editable.mime_type.split('/')[0]
          let img = type === 'image'
          this.editable.type = img
          this.editable.indice = i
        }
      },

      inputFilter (newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
          // Before adding a file
          // Filter system files or hide files
          if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
            return prevent()
          }
          // Filter php html js file
          if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
            return prevent()
          }
        }

        if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
          // Create a blob field
          newFile.blob = ''
          let URL = window.URL || window.webkitURL
          if (URL && URL.createObjectURL) {
            newFile.blob = URL.createObjectURL(newFile.file)
          }
          // Thumbnails
          newFile.thumb = ''
          if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
            newFile.thumb = newFile.blob
          }
        }
      },

      inputFile (newFile, oldFile) {
        if (newFile && oldFile) {
          // update
          if (newFile.active && !oldFile.active) {
            // beforeSend+
            // min size
            if (newFile.size >= 0 && this.minSize > 0 && newFile.size < this.minSize) {
              this.$refs[this.id].update(newFile, { error: 'size' })
            }
          }
          if (newFile.error && !oldFile.error) {
            var self = this
            // error
            // Erros possíveis size, extension, timeout, abort, network, server, denied
            switch (newFile.error) {
              case 'extension':
                self.$toasted.error('Extensão não permitida')
                break
              case 'timeout':
                self.$toasted.error('O tempo de espera excedido.')
                break
              case 'abort':
                self.$toasted.error('Cancelado')
                break
              case 'network':
                self.$toasted.error('Problemas na rede, verifique sua internet')
                break
              case 'server':
                self.$toasted.error('O servidor não está respondendo, entre em contato com o desenvolvedor.')
                break
              case 'denied':
                self.$toasted.error('Arquivo negado pelo servidor.')
                break
            }
          }
          if (newFile.success && !oldFile.success) {
            this.images.push(JSON.parse(newFile.xhr.response))
            this.$refs[this.id].remove(newFile)
          }
        }
        if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
          if (this.uploadAuto && !this.$refs[this.id].active) {
            this.$refs[this.id].active = true
          }
        }
      },

      alert (message) {
        alert(message)
      },

      onEditFileShow (file) {
        this.editFile = { ...file, show: true }
        this.$refs[this.id].update(file, { error: 'edit' })
      },

      onEditorFile () {
        if (!this.$refs[this.id].features.html5) {
          this.alert('Your browser does not support')
          this.editFile.show = false
          return
        }
        let data = {
          name: this.editFile.name
        }
        if (this.editFile.cropper) {
          let binStr = atob(this.editFile.cropper.getCroppedCanvas({ width: this.minCroppedWidth, height: this.minCroppedHeight }).toDataURL(this.editFile.type).split(',')[1])
          let arr = new Uint8Array(binStr.length)
          for (let i = 0; i < binStr.length; i++) {
            arr[i] = binStr.charCodeAt(i)
          }
          data.file = new File([arr], data.name, { type: this.editFile.type })
          data.size = data.file.size
        }
        this.$refs[this.id].update(this.editFile.id, data)
        this.editFile.error = ''
        this.editFile.show = false
      },

      onAddFolader () {
        if (!this.$refs[this.id].features.directory) {
          this.alert('Your browser does not support')
          return
        }
        let input = this.$refs[this.id].$el.querySelector('input')
        input.directory = true
        input.webkitdirectory = true
        this.directory = true
        input.onclick = null
        input.click()
        input.onclick = (e) => {
          this.directory = false
          input.directory = false
          input.webkitdirectory = false
        }
      },

      onAddData () {
        this.addData.show = false
        let collection = this.collection
        if (!this.$refs[this.id].features.html5) {
          this.alert('Your browser does not support')
          return
        }
        let file = new window.File([this.addData.content], this.addData.name, {
          type: this.addData.type,
          collection: collection
        })
        this.$refs[this.id].add(file)
      }
    }
  }
</script>

<style lang="scss">
  .tab-pane {
    width: 100%;
  }
  .grabbable {
      cursor: move !important; /* fallback if grab cursor is unsupported */
  }

   /* (Optional) Apply a "closed-hand" cursor during drag operation. */
  .grabbable:active {
      cursor: grabbing !important;
  }
  .line-border {
    border: 1px solid #3a3f4c;
  }
  .upload-table-component {
    padding: 3px;
    border-radius: 3px;
    display: inline-block;
    width: 100%;
    .list-group-item.active {
      background: #3a3f4c;
    }
  }
  .upload-table {
    box-shadow: 0 0 0 1px rgb(226, 231, 236);
    margin-bottom: 0;
    border-radius: 0;

    .btn-group a, .btn-group button {
      background: none;
      border: none;
    }
    thead th {
      color: #fff;
      background: rgb(58, 63, 76);
    }
    tbody {
      tr {
        &:hover {
          background: rgba(196, 211, 234, 0.2);
        }
        &:nth-of-type(odd) {
          background: rgb(240, 245, 249);
        }
      }
    }
  }
  .filename {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 223px;
  }
  .image-editable {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(14, 15, 23, 0.78);
    top: 0;
    left: 0;
    z-index: 9999;
    .editable-close {
      font-size: 15px;
      margin-bottom: 6px;
      text-decoration: underline;
    }
    .body-editable {
      background: #fbfbfb;
      height: 100%;
      box-shadow: 4px 8px 28px rgba(0, 0, 0, 0.61);
      position: fixed;
      right: 0;
      top: 0;
      width: 403px;
      overflow: auto;
      padding-top: 80px;
      .bg-preview {
        position: absolute;
        width: 100%;
        height: 73%;
        left: 0;
        top: 0;
        z-index: -1;
        filter: blur(13px);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
      }
      .frame-preview-image {
        width: 179px;
        height: 120px;
        margin-top: 10px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        border: 2px solid transparent;
        background-color: rgba(249, 245, 245, 0.44);
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
      }
    }
  }
  .modal {
    background: rgba(24, 28, 33, 0.78);
  }

  .fade.show {
    display: inline-block;
  }
  .table-responsive {
    overflow: initial !important;
  }
  .table {
    overflow: auto !important;
  }
  .modal-backdrop.fade {
    display: none;
  }
  .upload-table-component .btn-group .dropdown-menu {
    display: block;
    visibility: hidden;
    transition: all .2s
  }
  .upload-table-component .btn-group:hover > .dropdown-menu {
    visibility: visible;
  }
  .upload-table-component label.dropdown-item {
    margin-bottom: 0;
  }
  .upload-table-component .btn-group .dropdown-toggle {
    margin-right: .6rem
  }
  .upload-table-component .filename {
    margin-bottom: .3rem
  }
  .upload-table-component .btn-is-option {
    margin-top: 0.25rem;
  }
  .upload-table-component .example-foorer {
    padding: .5rem 9px;
    background: #fff;
    text-align: right;
    box-shadow: 0px 0px 0px 1px #e2e7ec;
  }
  .upload-table-component .edit-image img {
    max-width: 100%;
  }
  .upload-table-component .edit-image-tool {
    margin-top: .6rem;
  }
  .upload-table-component .edit-image-tool .btn-group{
    margin-right: .6rem;
  }
  .upload-table-component .footer-status {
    padding-top: .4rem;
  }
  .upload-table-component .drop-active {
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    position: fixed;
    z-index: 9999;
    opacity: .6;
    text-align: center;
    background: #000;
  }
  .upload-table-component .drop-active h3 {
    margin: -.5em 0 0;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    font-size: 40px;
    color: #fff;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/Uploader.vue